var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowlineright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 40v176a8 8 0 01-16 0V40a8 8 0 0116 0zM117.66 50.34A8 8 0 00104 56v64H32a8 8 0 000 16h72v64a8 8 0 0013.66 5.66l72-72a8 8 0 000-11.32z"
  })));
}

export default SvgArrowlineright;